import type { Dispatch, SetStateAction } from 'react'
import { AnimatePresence, motion } from 'motion/react'
import type { SelectOption } from '../../../components/SelectCustom'
import { CustomerAreaSurfaceCard, customerMotionTransition } from '../customer-area'
import type { AddressEditorState } from './addressBookHelpers'
import type { AddressLabels } from './addressBookConfig'
import { AddressEditorFormFields } from './AddressEditorFormFields'
import { AddressEditorActionBar } from './AddressEditorActionBar'

type AddressEditorSectionProps = {
  open: boolean
  editingAddressId: string | null
  editorState: AddressEditorState
  setEditorState: Dispatch<SetStateAction<AddressEditorState>>
  labels: AddressLabels
  countryOptions: SelectOption[]
  isItalian: boolean
  saving: boolean
  formError: string
  reducedMotion: boolean
  onSubmit: () => void
  onClose: () => void
  savingLabel: string
}

export const AddressEditorSection = ({
  open,
  editingAddressId,
  editorState,
  setEditorState,
  labels,
  countryOptions,
  isItalian,
  saving,
  formError,
  reducedMotion,
  onSubmit,
  onClose,
  savingLabel,
}: AddressEditorSectionProps) => (
  <AnimatePresence initial={false}>
    {open ? (
      <motion.div
        initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 10 }}
        animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
        exit={reducedMotion ? { opacity: 0 } : { opacity: 0, y: -10 }}
        transition={customerMotionTransition}
      >
        <CustomerAreaSurfaceCard
          title={editingAddressId ? labels.editFormTitle : labels.addFormTitle}
          subtitle={labels.addFormSubtitle}
        >
          <AddressEditorFormFields
            editorState={editorState}
            setEditorState={setEditorState}
            labels={labels}
            countryOptions={countryOptions}
            isItalian={isItalian}
          />

          {formError ? (
            <p className="mt-3 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{formError}</p>
          ) : null}

          <AddressEditorActionBar
            reducedMotion={reducedMotion}
            saving={saving}
            editingAddressId={editingAddressId}
            labels={labels}
            savingLabel={savingLabel}
            onSubmit={onSubmit}
            onClose={onClose}
          />
        </CustomerAreaSurfaceCard>
      </motion.div>
    ) : null}
  </AnimatePresence>
)
